/**
 * Discover / About Naturium Page Scripts
 * Handles sliding parallax effects, video playback controls, and mobile pillars carousel
 */

(function () {
  'use strict';

  function initDiscover() {
    const page = document.querySelector('[data-discover-page]');
    if (!page || page.dataset.initialized === 'true') return;
    page.dataset.initialized = 'true';

    // 1. Sliding Parallax for the Three Banners
    initParallax();

    // 2. Hero Video Controls
    initVideoControls(page);

    // 3. Mobile Pillars Carousel
    initPillarsCarousel(page);
  }

  /**
   * Sliding Parallax Effect for [data-bg-parallax="true"]
   */
  function initParallax() {
    const parallaxElements = document.querySelectorAll('[data-bg-parallax="true"]');
    if (!parallaxElements.length) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) return;

    function updateParallaxPositions() {
      const vh = window.innerHeight;
      const isDesktop = window.innerWidth >= 1000;

      if (!isDesktop) {
        parallaxElements.forEach((el) => {
          el.style.removeProperty('--bg-parallax-y');
        });
        return;
      }

      parallaxElements.forEach((el) => {
        const rect = el.getBoundingClientRect();
        const elCenter = rect.top + rect.height / 2;
        const vhCenter = vh / 2;
        // Offset ratio: 0.22 creates a natural, elegant depth shift
        const rawOffset = (vhCenter - elCenter) * 0.22;
        const offset = Math.max(-140, Math.min(140, rawOffset));
        el.style.setProperty('--bg-parallax-y', `${offset.toFixed(1)}px`);
      });
    }

    window.addEventListener('scroll', updateParallaxPositions, { passive: true });
    window.addEventListener('resize', updateParallaxPositions, { passive: true });

    // Initial position calculation
    updateParallaxPositions();
  }

  /**
   * Hero Video Play/Pause Control
   */
  function initVideoControls(container) {
    const control = container.querySelector('[data-discover-video-control]');
    if (!control) return;

    const videos = container.querySelectorAll('.discover-video__element');
    if (!videos.length) return;

    control.addEventListener('click', (e) => {
      e.preventDefault();
      const isPlaying = control.classList.contains('is-playing');

      videos.forEach((video) => {
        if (isPlaying) {
          video.pause();
        } else {
          video.play().catch(() => {});
        }
      });

      control.classList.toggle('is-playing', !isPlaying);
      control.setAttribute('aria-label', isPlaying ? 'Play video' : 'Pause video');
    });
  }

  /**
   * Mobile Pillars Carousel Progress & Snap Scaling
   */
  function initPillarsCarousel(container) {
    const row = container.querySelector('[data-pillars-row]');
    const progressBar = container.querySelector('[data-pillars-progress-bar]');
    if (!row || !progressBar) return;

    let isMobile = window.innerWidth < 1000;
    const cells = row.querySelectorAll('.discover-pillar-cell');

    function updateCarousel() {
      if (!isMobile) return;

      const maxScroll = row.scrollWidth - row.clientWidth;
      if (maxScroll > 0) {
        const percent = Math.min(100, Math.max(0, (row.scrollLeft / maxScroll) * 100));
        // Map percent 0..100 to progress bar width 33%..100%
        const barWidth = 33.333 + (percent * 0.66667);
        progressBar.style.width = `${barWidth.toFixed(1)}%`;
      }

      // Active card detection
      const containerCenter = row.scrollLeft + row.clientWidth / 2;
      cells.forEach((cell) => {
        const cellCenter = cell.offsetLeft + cell.clientWidth / 2;
        if (Math.abs(containerCenter - cellCenter) < cell.clientWidth / 2) {
          cell.classList.add('is-center');
        } else {
          cell.classList.remove('is-center');
        }
      });
    }

    row.addEventListener('scroll', updateCarousel, { passive: true });

    window.addEventListener('resize', () => {
      isMobile = window.innerWidth < 1000;
      if (isMobile) updateCarousel();
    }, { passive: true });

    updateCarousel();
  }

  // Initialize on DOMContentLoaded and shopify:section:load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDiscover);
  } else {
    initDiscover();
  }

  document.addEventListener('shopify:section:load', initDiscover);
})();
